<template>
  <div id="oecko-media">
    <app-icon
      v-if="mediaError"
      name="blurOn"
      size="tiny"
      color="rgba(0,0,0,.2)"/>
    <img
      v-else-if="media && !mediaError"
      id="media-img"
      :src="mediaSrc" />
  </div>
</template>

<style lang="sass">
#oecko-media
  align-items: center
  display: flex
  justify-content: center
  height: 100%
  width: 100%
  svg
    animation: pulse 1.9s ease 0s infinite
  img
    &.landscape
      height: auto
      max-width: 100%
    &.portrait
      max-height: 100%
      width: auto
@keyframes pulse
  0%
    transform: scale(1)
  50%
    transform: scale(1.1)
  100%
    transform: scale(1)
</style>

<script>
import AppIcon from '@/components/icons/AppIcon.vue';

export default {
  name: 'Media',

  components: {
    AppIcon,
  },

  props: {
    type: String,
    media: String,
    entranceConfig: Object,
    id: Number,
  },

  data() {
    return {
      mediaError: false,
    };
  },

  computed: {
    mediaSrc() {
      const img = new Image();

      img.onload = () => {
        const orientation = img.height >= img.width ? "portrait" : "landscape";
        this.$el.querySelector('#media-img')
          .src = this.defineUrl(this.type, 'local');
        this.$el.querySelector("#media-img").classList.add(orientation);
      };

      img.onerror = () => {
        console.log('Le media doit être téléchargé');
        this.processMedia();
      };

      img.src = this.defineUrl(this.type, 'local');
    },
  },

  methods: {
    defineUrl(type, src) {
      const localServerUrl = process.env.VUE_APP_TOOLS_URL;
      const deviceID = JSON.parse(localStorage.getItem('initConfig')).deviceID;
      const serverUrl = JSON.parse(localStorage.getItem('initConfig')).serverUrl;

      if (this.entranceConfig) {
        let url;
        if (type === 'organization_logo') {
          if (src === 'local') {
            url = `${localServerUrl}/ol${this.entranceConfig.organizationLogoName}`;
          } else if (src === 'remote') {
            url = `${serverUrl}/api/get/organization/logo/${deviceID}?v=${Date.now()}`;
          }
        } else if (type === 'background_image') {
          if (src === 'local') {
            url = `${localServerUrl}/bg${this.entranceConfig.screenbgName}`;
          } else if (src === 'remote') {
            url = `${serverUrl}/api/get/organization/screenbg/${deviceID}?v=${Date.now()}`;
          }
        } else if (type === "apartment_logo") {
          if (src === 'local') {
            url = `${localServerUrl}/apt${this.media}`;
          } else if (src === 'remote') {
            url = `${serverUrl}/api/get/apartment/logo/${this.id}?v=${Date.now()}`;
          }
        }
        return url;
      } return null;
    },

    processMedia() {
      if (window.navigator.onLine) {
        const img = new Image();

        img.onload = () => {
          const orientation = img.height >= img.width ? "portrait" : "landscape";
          this.$el.querySelector("#media-img").classList.add(orientation);
          this.$el.querySelector('#media-img')
            .src = this.defineUrl(this.type, 'remote');
          let filename = '';

          if (this.type === 'organization_logo') {
            filename = `ol${this.media}`;
          } else if (this.type === 'background_image') {
            filename = `bg${this.media}`;
          } else if (this.type === "apartment_logo") {
            filename = `apt${this.media}`;
          }
          this.$store.dispatch('cacheFile', {
            fileUrl:
              this.defineUrl(this.type, 'remote'),
            fileName: filename,
          });
        };

        img.onerror = () => {
          console.log('Une erreur s\'est produite');
          this.mediaError = true;
        };
        img.src = this.defineUrl(this.type, 'remote');
      } else {
        console.log('Pas de connexion internet');
        this.mediaError = true;
      }
    },
  },
};
</script>
